//Remove pageview on load if modal is opened
window.noPageView = ['login', 'register', 'recover','account','change','codurile-mele'].indexOf(window.location.hash.substr(1)) >= 0;

var _xhr, _orgAjax = jQuery.ajaxSettings.xhr;
jQuery.ajaxSettings.xhr = function () { return _xhr = _orgAjax(); };
jQuery.fn.reverse = Array.prototype.reverse;
$.ajaxSetup({ headers: {'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')} });

//Bootstrap loading Button text default
$.fn.button.Constructor.DEFAULTS = {
    loadingText: 'Se trimite'
};

var caravanascroll;
var animations = {};
var viewportAnimate = (function() {

    var init = function() {
        $('.viewport-anim').each(function() {
            var tolerance = parseInt($(this).data('viewport-tolerance')) || 0;
            if ( $(this).is( ':in-viewport(' + tolerance + ')' ) ) {
                if ( !$(this).hasClass('timeline') ) {
                    $(this).removeClass('viewport-anim').addClass('timeline');
                    animations[$(this).data('viewport-timeline')].play();
                }
            }
        });
    }

    // Animations
    animations.despre1 = new TimelineMax({paused:true});
    animations.despre1
        .fromTo('.despre__section1 .scut', 0.3, {opacity:0, y:'-100%'}, {opacity:1, y:'0%', ease: Power2.easeOut})
        .fromTo('.despre__section1 .despre__bottle', 0.3, {opacity:0, y:'-100%'}, {opacity:1, y:'0%', ease: Power2.easeOut, onComplete:function(){
            moveBottle()
        }},'-=0.1')
        .fromTo('.despre__section1-bg-topright', 0.3, {x:'100%'}, {x:'0%', ease: Power2.easeOut})
        .fromTo('.despre__section1-bg-bottomleft', 0.3, {x:'-100%'}, {x:'0%', ease: Power2.easeOut},'-=0.1')
        .fromTo('.despre__section1 h1', 0.3, {opacity:0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut})
        .fromTo('.despre__section1 .despre__intro', 0.3, {opacity:0, x:'-100%'}, {opacity:1, x:'0%', ease: Power2.easeOut},'-=0.1')
        .fromTo('.despre__timeline-title', 0.3,  {opacity: 0}, {opacity: 1, ease: Power2.easeOut},'-=0.2')
        .fromTo('.despre__timeline', 0.3,  {opacity: 0}, {opacity: 1, ease: Power2.easeOut, onComplete:function(){
            $('.despre__timeline li:first-child a').trigger('click');
        }},'-=0.2');

    return {
    	init: init
    }
})();



$(window).load(function() {

	TweenMax.to($('.preloader'), .5, {
		delay: 0.5,
		opacity: 0,
		display: 'none',
        onComplete: function(){
            viewportAnimate.init();
            $(window).on('resize scroll', function() {
                viewportAnimate.init();
            });
        }
	});

	if ( $('main.home').length && window.location.search ) {
		var params = new URLSearchParams(window.location.search);
		var ad = params.get('ad');
		if (ad !== null) {
			if (ad == 'Bihor') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Bihor.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			} else if (ad == 'Mures') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Mures.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			} else if (ad == 'Timis') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Timis.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			} else if (ad == 'Sibiu') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Sibiu.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			} else if (ad == 'Arad') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Arad.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			} else if (ad == 'Bucuresti') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Bucuresti.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			} else if (ad == 'Cluj') {
				$('#videoModal .modal-body').html('<img src="/themes/bergenbier/img/hp/ad/Cluj.jpg" class="img-responsive img-ad">').parents('#videoModal').addClass('modalAd').modal();
			}
		}
		$('.img-ad').on('click', function(){
			$('#videoModal').modal('hide');
		});
	}

});

//Window scrollTo
function scrollToSection(target,scrolloffset,hash) {
	var _target = scrolloffset !== undefined ? $(target).offset().top - scrolloffset : target;
	TweenMax.to(window, 1, {
		scrollTo: _target,
		ease: Power2.easeInOut,
        complete:function(){
			if (hash !== undefined) {
            	history.replaceState({}, '', target);
			}
        }
	});
}

var $invoker;

$(document).ready(function() {

	var modals = new UserManagement();
	$(document).keepAwake();

	//Caravana Mobile Arrow Resize
	if ($('.vezi-lista').length){
		$('.vezi-lista-arrow').css({'border-width':'10px '+$(window).width()/2+'px'});
	}


    $('.menu-toggle').click(function(e){
        e.preventDefault();
        $(this).toggleClass('active');
        $('.menu').toggleClass('active');
        $('body').toggleClass('active');
        $('main').toggleClass('active');
    });

    if (window.matchMedia("(min-width: 768px)").matches) {
        $('.tab-pane').matchHeight({byRow: false});
    } else {
        $('.tab-pane').matchHeight({ remove: true });
    }

    if ($('#menu').length){
        var menuScroll = new IScroll('#menuScroll', {
			mouseWheel: true,
			scrollbars: 'custom',
			click: true
        });
    }

    if ($('#scroller').length){
        var myScroll = new IScroll('#scroller', {
            eventPassthrough: true,
            disablePointer: true,
            scrollX: true,
            scrollY: false,
            mouseWheel: false,
            disableTouch: false,
            disableMouse: false
        });
    }

    $('#videoModal').on('show.bs.modal', function (e) {
        $invoker = $(e.relatedTarget);
        $('#videoModal iframe').attr('src', 'https://www.youtube.com/embed/'+$invoker.data('video')+'?rel=0&showinfo=0&autoplay=1');
    }).on('shown.bs.modal', function (e) {
		$('.modal-backdrop').css('background','#000');
	});

    $('.btn-form').click(function(e){
		e.preventDefault();
        $(this).addClass('disabled');
        var target = $(this).data('target');
        $('#'+target).slideDown({complete:function(){
            $('html, body').animate({
                scrollTop: $('#'+target).offset().top-parseInt($('body').css('padding-top'))
            }, 500);
        }});
    });

    //regulament tracking
	$('.regulament').click(function(){
		if (window.ga) {
			ga('send', 'event', $(this).attr('title'),'Download','Regulament');
		}
	});

	//Caravana scroll events
	$('a.vezi-lista').click(function(){
		scrollToSection('.caravana-locations ul', -45);
	});
	$('a.vezi-harta, a.back-harta').click(function(){
		scrollToSection('.section2', -60);
	});
	if ($('#caravanalocations').length){
		caravanascroll = new IScroll( '#caravanalocations', {
			mouseWheel: true,
			scrollbars: 'custom'
		});
	}

	window.poi = new CaravanaPOI();

});

$(window).on('resize', function() {
  if (window.matchMedia("(min-width: 768px)").matches) {
        $('.tab-pane').matchHeight({byRow: false});
		if ($('#caravanalocations').length){
			if (!caravanascroll.enabled) {
				caravanascroll.enable();
			}
		}
    } else {
        $('.tab-pane').matchHeight({ remove: true });
		//Caravana Mobile Arrow Resize
	  	if ($('.vezi-lista').length){
			$('.vezi-lista-arrow').css({'border-width':'10px '+$(window).width()/2+'px'});
		}
		if ($('#caravanalocations').length){
			if (caravanascroll.enabled) {
				caravanascroll.disable();
			}
		}
    }
}).on('load',function(){
	if (window.location.hash == "#codurile-mele") {
		$('.openPop[data-target="Coduri"]').trigger('click');
	}
});

$('.modal-backdrop, #videoModal .close, #videoModal .btn, #videoModal:not(.modal-content), #videoModal:not(.modal-body), #videoModal:not(.modal-header)').on('click', function() {
	$('#videoModal iframe').attr('src', '');
});
